// extracted by mini-css-extract-plugin
export default {"delBtn":"NotificationDetails_delBtn__6RI5v"};